import { WebserviceUrl } from "@tm/data/webserviceUrls"
import { ajaxAuth } from "@tm/utils"
import { GetQueryTypesRequest, GetQueryTypesResponse } from "./models"

export function getQueryTypes(body: GetQueryTypesRequest) {
    const url = `${WebserviceUrl.CisCustomer}/GetQueryTypes`

    return ajaxAuth<GetQueryTypesResponse>({ url, body }).then((response) => response?.queryTypes || [])
}
